import React from 'react'
import { Navigate } from 'react-router-dom'
import Private from '../../pages/_layouts/Private'

import { useAuthStore } from '../../store/auth'

export interface PrivateRouteProps {
  Component: React.FunctionComponent
  title?: string
  fullPage?: boolean
}

const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = ({
  Component,
  title,
  fullPage,
}) => {
  const { signed } = useAuthStore((state) => state)

  return (
    <Private fullPage={fullPage} title={title}>
      {signed ? <Component /> : <Navigate to='/login' />}
    </Private>
  )
}

export default PrivateRoute
